import {
    ChangeDetectionStrategy,
    Component,
    ComponentFactoryResolver,
    ComponentRef,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewContainerRef
} from '@angular/core';

import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs/internal/Subscription';
import '../../../shared/components/navigable';

@Component({
    selector: 'app-content-page',
    templateUrl: './content-page.component.html',
    styleUrls: ['./content-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentPageComponent implements OnInit, OnDestroy, Navigable {
    static readonly COMPONENT_ID = 'ContentPageComponent';

    @ViewChild('contentContainer', {read: ViewContainerRef, static: true})
    contentPage: ViewContainerRef;

    contentComponent: ComponentRef<any>;

    private routeDataChanged$: Subscription;

    constructor(private componentFactoryResolver: ComponentFactoryResolver,
                private route: ActivatedRoute) {
    }

    ngOnInit() {
        this.routeDataChanged$ = this.route.data.subscribe(data => this.processData(data));
    }

    ngOnDestroy(): void {
        this.routeDataChanged$.unsubscribe();
    }

    processData(data) {
        if (!(!!data || !!data.contentComponent)) {
            return;
        }

        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(data.contentComponent);

        this.contentPage.clear();
        this.contentComponent = this.contentPage.createComponent(componentFactory);
    }

    getId(): string {
        return ContentPageComponent.COMPONENT_ID;
    }
}
